import { useState, type MouseEvent, type ReactNode } from 'react';
import { IconButton, Menu, Box } from '@mui/material';
import { FilterList as FilterListIcon } from '@mui/icons-material';

interface ColumnFilterMenuProps {
  /** Whether this column currently has an active filter applied (controls icon color). */
  active: boolean;
  /** Accessible label for the filter trigger button. */
  label: string;
  /** Called when the menu is opened — use to resync draft state from the current URL params. */
  onOpen?: () => void;
  /** Render prop receiving a `close` callback so menu content can dismiss itself (e.g. after Apply). */
  children: (close: () => void) => ReactNode;
}

export function ColumnFilterMenu({ active, label, onOpen, children }: ColumnFilterMenuProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpen = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    onOpen?.();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        size="small"
        aria-label={label}
        onClick={handleOpen}
        color={active ? 'primary' : 'default'}
      >
        <FilterListIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
      >
        <Box sx={{ p: 2, minWidth: 220 }}>{children(handleClose)}</Box>
      </Menu>
    </>
  );
}
